/* eslint-disable semi */

export default class Schema {
  constructor (schema) {
    this.schema = schema;
  }

  get props () {
    return this.schema.props;
  }

  get default () {
    const result = {};
    for (const prop in this.schema.props) {
      result[prop] = ('default' in this.schema.props[prop]) ? this.schema.props[prop].default : null;
    }
    return result;
  }

  /**
   * 指定したタグ条件に合致するプロパティのみを保持するスキーマを返却します
   * @param {*} tags
   */
  filter (tags = null) {
    // TODO 他に複写すべきスキーマ定義があれば追加
    const schema = {
      props: {}
    }

    // sringが渡された場合は","で区切って配列形式に変換して扱う
    if (typeof tags === 'string') {
      tags = tags.split(',').map((k) => k.trim());
    }

    const props = this.schema.props;
    Object.keys(props).filter((prop) => {
      if (this.isPropMatchesAllTags(tags, props[prop])) {
        schema.props[prop] = props[prop];
      }
    })

    return new Schema(schema);
  }

  /**
   * すべてのタグ条件に合致するか判定
   */
  isPropMatchesAllTags (tags, prop) {
    if (!tags) {
      return true;
    }

    for (const idx in tags) {
      if (!this.isPropMatchesTag(tags[idx], prop)) {
        return false;
      }
    }

    return true;
  }

  /**
   * タグ条件に合致するか判定
   * 先頭が"!"でない場合は指定したタグに合致する場合に正
   * 先頭が"!"の場合は指定したタグに合致しない場合に正
   */
  isPropMatchesTag (tag, prop) {
    const tags = prop.tags || [];

    let mode;
    let cond;

    if (tag[0] !== '!') {
      mode = true;
      cond = tag;
    } else {
      mode = false;
      cond = tag.substr(1);
    }

    return (tags.includes(cond)) ? mode : !mode;
  }
}



// WEBPACK FOOTER //
// ./src/core/libs/Schema.js